// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/hotel-classification-business-list-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    businessName: {
      type: 'string',
      nullable: true,
    },
    classificationExpirationDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    classificationStars: {
      type: 'string',
      nullable: true,
    },
    classificationComment: {
      type: 'string',
      nullable: true,
    },
    isClassified: {
      type: 'boolean',
    },
    canRequestClassification: {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
